
{
      "BASE_URL": "https://adminapi.shiftclockai.com/",
     "APPLICATION_BASEURL":"https://adminapi.shiftclockai.com/"
}